@if (faqListToggleable().length > 0) {
<nz-collapse
  nzAccordion
  nzExpandIconPosition="end"
  [ngClass]="{ 'down-up-arrows': mode === 'down-up', 'text-arrow-padding': textArrowPadding }"
>
  @for (faq of faqListToggleable(); let index = $index; track faq.id) {
    @if (faq) {
      <nz-collapse-panel
        [nzHeader]="faq.title"
        [nzActive]="faq.id | isFaqActive: activeStatesSignal(): selectedId"
        (nzActiveChange)="onActiveChange(faq.id, $event)"
        [ngClass]="{
          'active-arrow-primary': (faq.id | isFaqActive: activeStatesSignal(): selectedId) && activeArrowAsPrimary,
          'prevent-bottom-border': faq.preventBottomBorder,
          'highlight': faq.highlight,
          'no-x-pad': !basicPadding,
        }"
        [nzTooltipTitle]="faq.tooltipContent ? faqTooltip : null"
        nzTooltipOverlayClassName="lean"
        nz-tooltip
        autoCloseOnScroll
        [nzTooltipVisible]="isTooltipVisible(index)"
        (nzTooltipVisibleChange)="onTooltipVisibleChange(index, $event)"
        (click)="faq.tooltipContent && onTooltipVisibleChange(index, !isTooltipVisible(index))"
      >
        @if (faq.contentTemplate) {
          <ng-container *ngTemplateOutlet="faq.contentTemplate; context: getFaqTemplateContext(faq)"></ng-container>
        } @else if (faq.contentHtml) {
          <div [innerHTML]="faq.contentHtml"></div>
        }
      </nz-collapse-panel>
      <ng-template #faqTooltip>
        <liberro-tooltip-content>
          <div tooltipContent>
            {{ faq.tooltipContent }}
          </div>
        </liberro-tooltip-content>
      </ng-template>
    }
  }
</nz-collapse>
<ng-content></ng-content>
} @else {
  <div>
    <p>{{ 'faq.search.noResults' | translate }}</p>
  </div>
}
@if (showMoreLinkLabel && showMoreLinkUrl) {
  <liberro-show-more-link
    [label]="showMoreLinkLabel"
    [link]="showMoreLinkUrl"
    suffixIcon="pointing-arrow.svg"
    [ngClass]="{ 'center-link': alwaysCenter }"
  ></liberro-show-more-link>
}
